import { Home } from '@mui/icons-material'
import { RouteKeyEnum } from 'src/routes'
import { BreadcrumbItem } from '@common/components/Breadcrumb'
export const USER_MANAGEMENT_BREADCRUMB_ITEMS = [
  {
    title: 'Home',
    route_key: RouteKeyEnum.HOME,
    icon: Home,
  } as BreadcrumbItem,
  {
    title: 'Users',
    route_key: RouteKeyEnum.USERS_MANAGEMENT,
  } as BreadcrumbItem,
]
